import type { NotificationModel } from '../common/dtos/notification.dto';

interface StaleCheckAlert {
  paymentId: number;
  checkNumber: string | null;
  amount: string;
  recipientName: string;
  daysSinceMailed: number;
}

interface NotificationsState {
  notificationsList: NotificationModel[];
  countOfNotifications: number;
  staleCheckAlerts: StaleCheckAlert[];
}

export const useNotifications = defineStore('notifications', {
  state: (): NotificationsState => ({
    notificationsList: [],
    countOfNotifications: 0,
    staleCheckAlerts: [],
  }),
  getters: {
    totalUnseen(): number {
      return this.countOfNotifications + this.staleCheckAlerts.length;
    },
  },
  actions: {
    async fetchList() {
      const { $snapApi } = useNuxtApp();
      const res = await $snapApi({ method: 'get', url: 'notifications' });
      if (res && res.status === 200) {
        this.notificationsList = res.data.data;
      }
    },
    async fetchCount() {
      const { $snapApi } = useNuxtApp();
      const res = await $snapApi({ method: 'get', url: 'unseen' });
      if (res && res.status === 200) {
        this.countOfNotifications = res.data.snapSize;
      }
    },
    async fetchStaleChecks() {
      const { $snapApi } = useNuxtApp();
      try {
        const res = await $snapApi({ method: 'get', url: 'check-intelligence?status=outstanding' });
        if (res && res.status === 200) {
          const now = Date.now();
          this.staleCheckAlerts = (res.data as any[])
            .filter((c) => c.mailedAt && (now - new Date(c.mailedAt).getTime()) / (1000 * 60 * 60 * 24) > 30)
            .map((c) => ({
              paymentId: c.paymentId,
              checkNumber: c.checkNumber,
              amount: c.amount,
              recipientName: c.recipientName,
              daysSinceMailed: Math.floor((now - new Date(c.mailedAt).getTime()) / (1000 * 60 * 60 * 24)),
            }));
        }
      } catch {
        // Check intelligence may not be available for all accounts
      }
    },
  },
});
